import React, {
  createContext,
  useContext,
  useReducer,
  Dispatch,
  ReactNode,
} from "react";
import { State, Action } from "../reducer";

// Define the shape of our context value — tuple of [state, dispatch]
type StateContextType = [State, Dispatch<Action>];

// Create a context with this type (can initially be undefined)
const StateContext = createContext<StateContextType | undefined>(undefined);

// Props for the provider component
interface StateProviderProps {
  reducer: (state: State, action: Action) => State;
  initialState: State;
  children: ReactNode;
}

// The provider wraps the app and provides state + dispatch
export const StateProvider: React.FC<StateProviderProps> = ({
                                                              reducer,
                                                              initialState,
                                                              children,
                                                            }) => {
  const value = useReducer(reducer, initialState);
  return <StateContext.Provider value={value}>{children}</StateContext.Provider>;
};

// Hook to consume the context safely
export const useStateValue = (): StateContextType => {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error("useStateValue must be used within a StateProvider");
  }
  return context;
};
